var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSquareSpoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 236,
    viewBox: "0 0 184 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 236V17.08C0 7.64999 6.56997 0 14.66 0H169.34C177.43 0 184 7.64999 184 17.08V236H0Z",
    fill: "#FF9685"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8801 157.2C61.6301 156.76 56.0401 155.92 49.6401 139.79C47.9601 135.54 43.0301 119.34 44.1101 94.36C45.5601 60.52 68.4102 24.49 90.4002 23.15C112.39 21.81 133.76 63.08 134.6 93.5C135.04 109.32 134.6 128.81 128.25 139.18C123 147.67 119.08 155.92 110.79 157.34C96.9201 159.72 68.0001 157.21 67.8801 157.2Z",
    fill: "#FFB4AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9102 236L80.4802 182.48C80.4802 171.14 72.2703 160.94 62.0303 156.09L114.85 155.92C106.91 161 98.0002 172.57 98.0002 182L98.6403 236H79.9102Z",
    fill: "#FFB4AE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareSpoon);
export default __webpack_public_path__ + "static/media/square_spoon.d13822b83c5eeaf0264101bd8ace12e1.svg";
export { ForwardRef as ReactComponent };